const getRuntimeEnvironment = () => (
  typeof window !== 'undefined' && window.__ENV ? window.__ENV : {}
);

const parseThreshold = value => {
  const thresholdMs = Number(value);
  return Number.isFinite(thresholdMs) && thresholdMs > 0 ? thresholdMs : null;
};

export const getRuntimeClockSkewPolicy = () => {
  const environment = getRuntimeEnvironment();

  return {
    thresholdMs: parseThreshold(environment.REACT_APP_CLOCK_SKEW_THRESHOLD_MS),
  };
};

export default getRuntimeClockSkewPolicy;
